import * as find from './reducers/find';
import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    LANGUAGES_FIND_REQUEST: find.request,
    LANGUAGES_FIND_FINISH: find.finish,
    LANGUAGES_FIND_ERROR: find.error,
});
